import { telegramLink } from "../utils/contact";


export const siteConfig = {
  name: "OnePlace Deal",
  tagline: "Le bon professionnel, à portée de message",
  shortDescription:
    "OnePlace Deal met en relation des particuliers avec des professionnels de confiance  puis laisse la conversation se poursuivre directement sur WhatsApp ou Telegram.",
  longDescription:
    "OnePlace Deal est une vitrine qui présente des prestataires de services indépendants : leur profil, leurs prestations, leurs tarifs et leurs réalisations. Aucune messagerie interne, aucun paiement en ligne : vous choisissez un professionnel, vous consultez ses informations, puis vous le contactez directement via WhatsApp ou Telegram pour organiser la prestation.",
  url: "https://OnePlacedeal.com",
  email: "oneplacedealadmin@gmail.com",
  supportPhone: "+31617362533",
  whatsappNumber: "+31 6 17362533",
  telegramHandle: "https://t.me/m/-xnBNtYTZTE0",
  address: "Belgique, Liège",
  legalEntity: "OnePlace Deal SARL",
  foundedYear: 2024,
  defaultCurrency: "USD" as const,
  socials: {
    facebook: "https://www.facebook.com/profile.php?id=61594518279920",
    instagram: "https://www.instagram.com/oneplacedeal?stkn=MW9nbW5pdWs3dnozcw==",
    telegramLink: "https://t.me/m/-xnBNtYTZTE0",
   
  },
  stats: {
    professionals: 240,
    citiesCovered: 12,
    countriesCovered: 6,
    satisfactionRate: 97,
  },
};

export const navLinks = [
  { label: "Accueil", to: "/" },
  { label: "Profils", to: "/profils" },
  { label: "Produits", to: "/produits" },
  { label: "À propos", to: "/a-propos" },
];

export const footerLinks = {
  plateforme: [
    { label: "Accueil", to: "/" },
    { label: "Tous les profils", to: "/profils" },
    { label: "Tous les produits", to: "/produits" },
  ],
  entreprise: [
    { label: "À propos", to: "/a-propos" },
    { label: "Contact", to: "/contact" },
    { label: "Mes favoris", to: "/favoris" },
  ],
  legal: [
    { label: "Mentions légales", to: "/mentions-legales" },
    { label: "Politique de confidentialité", to: "/confidentialite" },
    { label: "Conditions d'utilisation", to: "/conditions-utilisation" },
  ],
};
